import Modal from 'components/Modal';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import services from 'services';
import actions from 'state/actions';
import modalActions from 'state/modal/actions';
import selectors from 'state/selectors';
import utils from 'utils';

const MassiveValidation = () => {
  const dispatch = useDispatch();
  const idProgram = useSelector(selectors.app.getProgramCode);
  const idUser = useSelector(selectors.user.getIdUser) || -1;
  const records = useSelector(selectors.documents.selectTableRows);
  const [errorProtocols, setErrorProtocols] = useState<number[]>([]);
  const t = utils.intl.useTranslator();
  const [visbility, setVisibleError] = useState(false);
  const [ModalError] = utils.hooks.useBulkActionErrorModal(errorProtocols, visbility);

  const onConfirm = async () => {
    const recordsArray = records.map((rec) => rec.protocol);
    try {
      const { data } = await services.validateDocument({
        idProgram,
        idUserQualityCheck: idUser,
        protocols: recordsArray,
        forceSubmit: true,
      });
      if (data.success === false) {
        setErrorProtocols(data.protocols);
        // open errors modal
        setVisibleError(true);
        const toDelete = recordsArray.filter((prot) => !data.protocols.includes(prot));
        dispatch(actions.documents.removeRows(toDelete));
      } else {
        dispatch(actions.documents.removeRows(recordsArray));
        utils.app.notify('success', t('success-mass-validate'));
        dispatch(modalActions.closeModal());
      }
    } catch (e) {
      utils.app.notify('fail', t('failed-mass-validate'));
      console.error(e);
    }
  };

  return (
    <>
      {visbility ? (
        <ModalError />
      ) : (
        <>
          <Modal.Header title="Confirm" subtitle="Are you sure you want to continue?" />
          <Modal.Footer confirmText="Confirm" confirmAction={onConfirm} />
        </>
      )}
    </>
  );
};

export default MassiveValidation;
